module.exports = __webpack_public_path__ + "static/media/columnSelected.490800c1.svg";